import { RegisterWidgets } from "../Widgets/RegisterWidgets"

export const Register = () => {
    return (
        <>
            <RegisterWidgets />
        </>
    )
}